import { CrewMember, RodFillerMaterial, RodRequest, Caddy, CaddyFillerMaterialDiameter } from '@bechtel/types';

export enum CaddyTabType {
  ADD = 'ADD',
  ISSUED = 'ISSUED',
}

export interface CaddyTab {
  label: string;
  value: CaddyTabType;
}

export interface RodRequestCaddyProps {
  rodRequestDetail: RodRequest;
}

export interface ProgressDetail {
  welder: CrewMember;
  returnedCaddies: number;
  totalCaddies: number;
}

export interface RodRequestProgressWeld {
  id: RodRequest['id'];
  requestNumber: RodRequest['requestNumber'];
  welds: RodRequest['welds'];
  stencils: RodRequest['stencils'];
}
